import { Injectable } from '@angular/core';
import { Headers, Http, Response } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class GeoJsonService {
    private subURL: string = "http://cloud.agroclimate.org/tools/kddMonitoring/ws/";
    constructor(private http: Http) {
    }

    getGeoJson(period: number, baseTemp: number, variable: string) {
        let url = this.subURL + "geojson.php?p=" + period + "&geoid=USFL,USGA,USAL,USLA,USMS,USAR,USTN,USNC,USSC,USKY,USVA" + "&b=" + baseTemp + "&var=" + variable;
        return this.http.get(url)
            .map((response: Response) => response.json())
            .catch((error: Response) => Promise.reject(error));
    }

    getLegendInfo(variable: string) {
        let legendUrl = this.subURL + "legend.php?var=" + variable;
        return this.http.get(legendUrl)
            .map((response: Response) => response.json())
            .catch((error: Response) => Promise.reject(error));
    }

    getBorderGeoJson() {
        let url = this.subURL + "geojsonshp.php?geoid=USFL,USGA,USAL,USLA,USMS,USAR,USTN,USNC,USSC,USKY,USVA";
        return this.http.get(url)
            .map((response: Response) => response.json())
            .catch((error: Response) => Promise.reject(error));
    }

    getLatestDate(variable: string) {
        let url = this.subURL + "getLatestDate.php?var=" + variable;
        return this.http.get(url)
            .map((response: Response) => response.json())
            .catch((error: Response) => Promise.reject(error));
    }
}



// WEBPACK FOOTER //
// ./src/app/services/geo-json.service.ts